import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { RateType } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { useCompanyCurrency } from '~hooks/useCompanyCurrency/useCompanyCurrency';
import { Invoice } from '~hooks/useInvoices/models';
import { getRateTypeLabel } from '~pages/Settings/RatesManagement/rateUtils';
import { getFormattedRateValue } from '~pages/Settings/RatesManagement/rateUtils';

interface TotalQuantityColumnProps {
  invoice: Invoice;
  sx?: SxProps<Theme>;
}

const TotalQuantityColumn = ({ invoice, sx }: TotalQuantityColumnProps) => {
  const { currencyFormatter } = useCompanyCurrency();

  return (
    <Box sx={sx}>
      <OverflowAwareText>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 700,
          }}
        >
          {currencyFormatter(invoice.totalAmount)}
        </Typography>
      </OverflowAwareText>
      <OverflowAwareText>
        {getFormattedRateValue(
          invoice.rateType ?? RateType.RATE_PER_HOUR,
          invoice.rateValue ?? 0,
          currencyFormatter,
        )}{' '}
        {invoice.rateType ? getRateTypeLabel(invoice.rateType) : ''}
      </OverflowAwareText>
      {invoice.addOnChargesCount > 0 && (
        <>
          <OverflowAwareText pt={0.5}>{`${t('common.add_ons')}:`}</OverflowAwareText>

          <OverflowAwareText>
            {`${currencyFormatter(invoice.addOnChargesTotalAmount)} (${invoice.addOnChargesCount})`}
          </OverflowAwareText>
        </>
      )}
    </Box>
  );
};

export default TotalQuantityColumn;
